import Joi from 'joi';
import { forConsole } from '../channels';
import { actionCreator, objectSchemaOf } from '../helpers';
export const ANNOUNCEMENT = 'NOTIFICATIONS/ANNOUNCEMENT';

export interface IAnnouncementPayload {
  consoleId: string;
  announcementId: string;
  conversationId: string;
  timestamp: number;
  text: string;
  recipientName?: string;
}

export const announcementPayloadSchema = objectSchemaOf<IAnnouncementPayload>({
  consoleId: Joi.string().required(),
  announcementId: Joi.string().required(),
  conversationId: Joi.string().required(),
  timestamp: Joi.number().required(),
  text: Joi.string().required(),
  recipientName: Joi.string().optional(),
});

export const announcementActionSchema = objectSchemaOf<IAnnouncementAction>({
  type: Joi.string().required().valid(ANNOUNCEMENT),
  payload: announcementPayloadSchema.required(),
});

export interface IAnnouncementAction {
  type: typeof ANNOUNCEMENT;
  payload: IAnnouncementPayload;
}

export const announcement = actionCreator({
  type: ANNOUNCEMENT,
  schema: announcementActionSchema,
  channels: [forConsole],
});
